module.exports = __webpack_public_path__ + "img/back-da@3x.402bd1c5.svg";